angular.module('unica_report.report_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// REPORT
		.state('app.report', {
			url: '/report',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/report/templates/report.html',
					controller: 'ReportBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// REPORT LIST
			.state('app.report.list', {
				url: '/list/:event_id',
				views: {
					'reportContent': {
						templateUrl: './modules/report/templates/list.html',
						controller: 'ReportListController'
					}
				},
				resolve: {
					store: function ($ocLazyLoad) {
						return $ocLazyLoad.load({
							serie: true,
							name: 'chart.js',
							files: [
								'/js/app/vendor/report.js'
							]
						});
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Report',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

});
